import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from '@angular/common';
import { AppBarTitleService } from 'common';
import { LogDetailsData } from '../log.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-log-details',
    templateUrl: './log-details.component.html',
    styleUrls: ['./log-details.component.scss'],
    standalone: false
})
export class LogDetailsComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private appBarTitleService: AppBarTitleService) { }

  data: LogDetailsComponentData;

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe(it => this.data = it);
    this.appBarTitleService.title = this.data.details.log.logger + ', '
      + formatDate(this.data.details.log.timestamp, 'EEE, MM/dd/yyyy h:mm:ss:SS a', 'en_US');
  }

  getJson(): JSON {
    return JSON.parse(this.data.details.json);
  }

}

export interface LogDetailsComponentData {
  details?: LogDetailsData;
}
